import React, { useState } from 'react';
import { Dropdown } from "react-bootstrap";
import { BsFillGrid1X2Fill } from "react-icons/bs";
import { FaUser } from "react-icons/fa6";
import { Link } from 'react-router-dom';
import { RxHamburgerMenu } from "react-icons/rx";
import MobileSidebarLinks from '../Components/OffcanvasMenu/MobileSidebarLinks';
import ResizeHook from '../Components/Hooks/ResizeHook';
import Logo from "../assets/img/listing.png";

const Header = () => {
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);

  const widthResize = ResizeHook();
  
  const handleCloseHeader = () => {
    setShow(false);
  }

  return (
    <>
      <header className="header">
        <div className="headerbox">
          {
            widthResize > 991 ?
              <div>
                <p className="headerbox_head">Welcome Admin</p>
                <div className="headerbox_icon"><BsFillGrid1X2Fill /></div>
                <Dropdown className="headerbox_drop">
                  <Dropdown.Toggle><FaUser /></Dropdown.Toggle>
                  <Dropdown.Menu>
                    {/* <Link to="/user" className="dropdown-item">Profile</Link>
                    <Dropdown.Divider /> */}
                    <Link to="/" className="dropdown-item">Logout</Link>
                  </Dropdown.Menu>
                </Dropdown>
              </div> :
              <div className="d-flex align-items-center justify-content-between">
                <Link to="/dashboard">
                  <img src={Logo} alt="Edaface" className="img-fluid logo" />
                </Link>
                <button type="button" className="btn mobtoggle" onClick={handleShow}>
                  <RxHamburgerMenu />
                </button>
              </div>
          }
        </div>
      </header>
      <MobileSidebarLinks show={show} handleClose={handleClose} handleCloseHeader={handleCloseHeader} />
    </>
  )
}

export default Header;